export enum RewardDescription {
  bigPrize = 'big-prize',
  midPrize = 'mid-prize',
  smallPrize = 'small-prize',
  instantWoHump = 'instant-wo-hump',
  instantWHump = 'instant-w-hump',
  none = 'none',
}
